import { Pipe, PipeTransform } from "@angular/core";
import { ActionButtonDto, ReportDto } from "@api";

@Pipe({ name: "isRelatedToReport" })
export class IsRelatedToReportPipe implements PipeTransform {
  public transform(actionButton: ActionButtonDto, reports: ReportDto[]): boolean {
    if (!actionButton || !reports?.length) return false;
    return reports.some(report => report.isBottleneck);
  }
}
